import React, { Fragment } from "react";
import PropTypes from "prop-types";
import TextField from "form/components/text-field";
import { translate } from "application/functions";
// import { includes } from "ramda";
// import { getMarket, isFromGermany } from "application/functions";
// import { telephoneRequiredStoreIds } from "application/constants/app-constants";

const PersonalInfo = (props) => {
  const { register, errors, locale, isSubmitted } = props;

  return (
    <Fragment>
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        field="name"
        label={translate("field.firstName", locale)}
        required
        isSubmitted={isSubmitted}
      />
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        field="surname"
        label={translate("field.lastName", locale)}
        required
        isSubmitted={isSubmitted}
      />
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        label={translate("field.email", locale)}
        field="email"
        regex="^\S+@\S+$"
        required
        isSubmitted={isSubmitted}
      />
      <TextField
        register={register}
        errors={errors}
        locale={locale}
        label={translate("field.phone", locale)}
        field="phone"
        required={false}
        isSubmitted={isSubmitted}
      />
    </Fragment>
  );
};

PersonalInfo.propTypes = {
  register: PropTypes.any,
  errors: PropTypes.any,
  locale: PropTypes.string,
  isSubmitted: PropTypes.bool,
};

export default PersonalInfo;
